export default "__VITE_ASSET__DFiq1uLb__"